import { Box, Grid, Skeleton } from '@mui/material'

export const EarningsChartSkeleton = () => (
  <Box>
    <Grid
      alignItems="flex-end"
      container
      height={360}
      justifyContent="flex-start"
      spacing={2}
    >
      <Grid item xs={2}>
        <Skeleton height={160} variant="rectangular" width="100%" />
      </Grid>
      <Grid item xs={2}>
        <Skeleton height={180} variant="rectangular" width="100%" />
      </Grid>
      <Grid item xs={2}>
        <Skeleton height={80} variant="rectangular" width="100%" />
      </Grid>
      <Grid item xs={2}>
        <Skeleton height={140} variant="rectangular" width="100%" />
      </Grid>
      <Grid item xs={2}>
        <Skeleton height={80} variant="rectangular" width="100%" />
      </Grid>
      <Grid item xs={2}>
        <Skeleton height={140} variant="rectangular" width="100%" />
      </Grid>
    </Grid>
  </Box>
)
